<template>
  <el-dialog
    :title="$t('deleteApp.title')"
    :visible.sync="dialogVisible"
    width="30%"
    center
  >
    <div class="text-center">
      <p>{{ $t('deleteApp.confirmDelete') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('deleteApp.cancel') }}
      </el-button>
      <el-button
        type="primary"
        @click="deleteApp"
      >
        {{ $t('deleteApp.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteApp } from '@/api/dev/appApi'

export default {
  name: 'DeleteApp',
  data() {
    return {
      dialogVisible: false,
      deleteAppInfo: {}
    }
  },
  methods: {
    open(app) {
      this.deleteAppInfo = { ...app }
      this.dialogVisible = true
    },
    async deleteApp() {
      try {
        await deleteApp(this.deleteAppInfo)
        this.$message.success(this.$t('deleteApp.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('success')
      } catch (error) {
        console.error('删除应用失败:', error)
        this.$message.error(error.message || this.$t('deleteApp.deleteFailed'))
      }
    }
  }
}
</script>